// fixes errors in scenarios

export default {
  name: "remove missing ids (measures/incidents) from scenarios",
  applyToVersions: "<1.32.2",
  type: "before",
  migrate(data) {
    const scenarios = data?.scenarios?.items || {};
    const measureIds = Object.keys(data?.measures?.items || {}).map((id) =>
      parseInt(id)
    );
    const incidentIds = Object.keys(data?.incidents?.items || {}).map((id) =>
      parseInt(id)
    );

    for (const scenarioId in scenarios) {
      const scenario = scenarios[scenarioId];
      scenario.measureIds = scenario.measureIds.filter((id) =>
        measureIds.includes(id)
      );
      scenario.incidentIds = scenario.incidentIds.filter((id) =>
        incidentIds.includes(id)
      );
    }

    return data;
  }
};
